import { DatePipe } from "@angular/common";

export class CommonUtil {

    static capitalizeFirstLetter = (str: string) => {
        const s = str.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
    
}